import React from 'react';
import { motion } from 'framer-motion';

const Spotlight = ({ 
  size = 800, 
  color = 'rgba(10, 182, 188, 0.1)', 
  className = '',
  animate = true 
}) => {
  return (
    <motion.div
      className={`absolute top-1/2 left-1/2 pointer-events-none z-0 ${className}`}
      style={{
        width: size,
        height: size,
        background: `radial-gradient(circle, ${color} 0%, rgba(4, 92, 67, 0.05) 50%, transparent 100%)`,
        transform: 'translate(-50%, -50%)',
      }}
      animate={animate ? {
        scale: [1, 1.1, 1],
        opacity: [0.5, 0.8, 0.5],
      } : {}}
      transition={{
        duration: 8,
        repeat: Infinity,
        ease: "easeInOut"
      }}
    />
  );
};

export default Spotlight;